// src/config.js

const config = {

   // 🔗 Backend API Link (Sabse Zaroori)
  apiUrl: "https://gym-api.raghuveerbhati525.workers.dev",
  // Business Details
  appName: "Body GYM",       // Gym ke liye: "FitLife Gym"
  branchName: "Bikaner Branch",   // Gym ke liye: "JNV Colony Branch"
  mainEmoji: "🏋️",                // Gym ke liye: "🏋️"
  
  // User Terminology
  userType: "Member",            // Gym ke liye: "Member"
  userTypePlural: "Members",     // Gym ke liye: "Members"
  
  // Plan Terminology
  planLabel: "Package",              // Gym ke liye: "Package"
  
  // Receipt Prefix
  receiptPrefix: "FIT",            // Gym ke liye: "FIT"
};

export default config;